<template>
  <div class="theme-light">
    <no-internet />
    <error-modal />
    <install-modal />
    <div
      class="fixed top-0 z-[49] w-full bg-background"
      :style="{ height: iosPlatformHeight }"
    />
    <div class="mt-2">
      <div
        v-if="appName && isBrand.length"
        class="flex justify-center text-sm text-grey text-opacity-30"
      >
        {{ appName }}
      </div>
      <div
        v-if="platformApp === 'Android' || platformApp === 'IOS'"
        class="flex space-x-2 justify-center"
      >
        <div
          v-if="platformApp"
          class="flex justify-center text-sm text-grey text-opacity-30"
        >
          {{ platformApp }}
        </div>
        <div
          v-if="appVersion"
          class="flex justify-center text-sm text-grey text-opacity-30"
        >
          v{{ currentAppVersion }}
        </div>
      </div>
      <div
        class="flex justify-center select-none"
        :class="currentRoutePath == '/notifications' ? 'space-x-2' : ''"
      >
        <div
          class="flex justify-center text-sm text-grey text-opacity-30"
          v-if="userData && userData.phone_number && currentRoutePath != '/'"
        >
          {{
            currentRoutePath != "/notifications"
              ? ""
              : "Выплаты аккаунта: " + userData.phone_number
          }}
        </div>
        <div
          v-if="platformApp === 'Pwa' || platformApp === 'Web'"
          class="flex justify-center text-sm text-grey text-opacity-30"
        >
          {{ platformApp }}
        </div>
      </div>
    </div>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <keep-alive :include="['HomeView', 'LoginPage', 'TelegramBanner']">
          <component :is="Component" />
        </keep-alive>
      </transition>
      <NewVersionModal
        @decline="hideNewVersionModal()"
        v-if="showNewVersionModal && isOnline"
      />
      <BlockedModal
        v-if="isBrand.length && brandIsActivate === false"
        class="absolute top-[50%] translate-y-[-50%] w-full h-full"
      />
    </router-view>

    <div v-if="layout" class="navigation-area z-20 bg-greyLight">
      <div
        @click="onClickTab(tab.route)"
        class="tab"
        :style="
          hasBottomPadding ? `padding-bottom: ${navigationBottomPadding}px` : ''
        "
        v-for="tab in navigationTabs"
        :key="tab.icon"
        :class="{ 'tab-active': tab.route === currentRoute }"
      >
        <div class="relative">
          <div
            class="tab-icon text-darkGrey"
            :class="{ 'text-greyLight': tab.route === currentRoute }"
          >
            <i :class="tab.icon" />
          </div>
          <div
            v-if="tab.route === '/documents' && newDocumentsCount > 0"
            class="absolute -top-1.5 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-red px-1 text-[10px] font-semibold leading-none text-white"
          >
            {{ newDocumentsCount }}
          </div>
        </div>
        <div class="text-[10px] text-grey">
          {{ tab.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import BlockedModal from "@/components/Modals/BlockedModal.vue";
import ErrorModal from "@/components/Modals/ErrorModal.vue";
import InstallModal from "@/components/Modals/InstallModal.vue";
import NewVersionModal from "@/components/Modals/NewVersionModal.vue";
import NoInternet from "@/components/Statuses/NoInternet.vue";
import { IAppVersion } from "@/struct/IAppVersion/IAppVersion";
import { IDocument } from "@/struct/IDocument/IDocument";
import { IUserData } from "@/struct/IStore/IStore";
import UtilStorage from "@/util/Common/UtilStorage";
import { App as CapacitorApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { SafeArea } from "capacitor-plugin-safe-area";
import { Action, Getter, Mutation } from "s-vuex-class";
import { Watch } from "vue-property-decorator";
import store from "./store";

@Options({
  components: {
    InstallModal,
    NoInternet,
    ErrorModal,
    NewVersionModal,
    BlockedModal,
  },
})
export default class App extends Vue {
  @Action("getBrandStatus") private getBrandStatus: (() => void) | undefined;

  @Mutation("setDeferredPrompt") private setDeferredPrompt:
    | ((value: any) => void)
    | undefined;
  @Action("getAppInfo") private getAppInfo: (() => void) | undefined;
  @Action("getAppVersion") private getAppVersion: (() => void) | undefined;
  @Getter("getAppVersion") private appVersion!: IAppVersion;
  @Getter("appName") private appName: string | undefined;
  @Action("getUserData") private getUserData: (() => void) | undefined;
  @Getter("getUserData") private userData: IUserData | undefined;
  public platform = Capacitor.getPlatform();
  @Getter("validateUserPlatform") private platformApp: string | undefined;
  @Getter("getDocuments") private documents!: IDocument[];
  $router: any;
  @Getter("getCurrentAppVersion") public currentAppVersion!: string;

  private isBrand = process.env.VUE_APP_BRAND_ID;
  private brandIsActivate: boolean | null = null;
  private hasBottomPadding = true;
  private isOnline = navigator.onLine;

  @Watch("$store.state.isActive")
  onBrandActivationChange(newValue: boolean) {
    this.brandIsActivate = newValue;
  }

  mounted() {
    CapacitorApp.addListener("appUrlOpen", async (data: { url: string }) => {
      const url = new URL(data.url);

      if (url.host === "login-yandex") {
        this.$router.push({
          path: "/login-yandex/",
          query: {
            code: url.searchParams.get("code"),
            state: url.searchParams.get("state"),
          },
        });

        try {
          await Browser.close();
        } catch (e) {
          console.error(e);
        }
      }
    });
  }

  get showNewVersionModal(): boolean {
    return this.$store.getters.showNewVersionModal;
  }

  get currentRoutePath(): string {
    return this.$route.path;
  }

  public checkVersion() {
    if (
      this.appVersion &&
      this.appVersion.detail &&
      this.appVersion.detail !== "VERSION_SUCCESSES"
    ) {
      return true;
    }
    return false;
  }

  public chechStore() {
    if (store.state.isOpenNewVersionModal === true) {
      document.body.style.overflow = "hidden";
      return true;
    } else {
      document.body.style.overflow = "visible";
      return false;
    }
  }

  public async openNewVersionModal() {
    if (!this.isOnline) {
      this.$store.commit("setIsOpenNewVersionModal", false);
      return;
    }

    if (!this.appVersion) {
      try {
        await this.getAppVersion?.();
      } catch (error) {
        console.error(error);
        return;
      }
    }

    if (
      this.appVersion?.detail !== "VERSION_SUCCESSES" &&
      (this.platform === "ios" || this.platform === "android")
    ) {
      this.$store.commit("setIsOpenNewVersionModal", true);
      console.log("Обновите приложение!");
    } else {
      console.log("Версия приложения актуальна!");
    }
  }

  public hideNewVersionModal() {
    this.$store.commit("setIsOpenNewVersionModal", false);
    this.chechStore();
  }

  public navigationBottomPadding = 10;
  private iosPlatformHeight: string | null = null;
  private navigationTabs: { icon: string; route: string; title: string }[] = [
    {
      icon: "fas fa-home",
      route: "/home",
      title: "Главная",
    },
    {
      icon: "fas fa-bell",
      route: "/notifications",
      title: "Уведомления",
    },
    {
      icon: "fas fa-user",
      route: "/profile",
      title: "Профиль",
    },
    // {
    //   icon: "fas fa-money-bill-wave",
    //   route: "/referral-page",
    //   title: "Бонусы",
    // },
    // {
    //   icon: "fas fa-folder-open",
    //   route: "/documents",
    //   title: "Документы",
    // },
    {
      icon: "fas fa-cog",
      route: "/settings",
      title: "Настройки",
    },
  ];

  get layout() {
    return this.$route.meta.layout || false;
  }

  get currentRoute() {
    return this.$route.path;
  }

  get newDocumentsCount(): number {
    return this.documents.filter((document) => document.isNew).length;
  }

  private onClickTab(link: string) {
    this.$router.replace(link);
  }

  private handleOnline() {
    this.isOnline = true;
  }

  private handleOffline() {
    this.isOnline = false;
  }

  created() {
    this.getBrandStatus?.();
    this.getAppInfo?.();
    if (this.$PLATFORM == "web") {
      window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault();
        this.setDeferredPrompt?.(event);
        UtilStorage.removeItem("appInstalled");
      });
    }
    this.getAppVersion?.();
    this.initializeSafeArea();

    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);

    setTimeout(() => {
      this.openNewVersionModal();
    }, 1000);
  }

  beforeUnmount() {
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  private async initializeSafeArea() {
    try {
      if (this.$PLATFORM === "ios") {
        const { insets } = await SafeArea.getSafeAreaInsets();
        this.iosPlatformHeight = `${insets.top}px`;
        this.hasBottomPadding = false;
      } else if (this.$IS_PWA && this.$IS_SAFARI) {
        this.hasBottomPadding = false;
      } else {
        this.hasBottomPadding = true;
      }
    } catch (e) {
      console.error("Ошибка при получении safe area insets", e);
      this.hasBottomPadding = true;
    }
  }
}
</script>
